import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSignInAlt, faSearch, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import DataTable from 'react-data-table-component';
import { customTableStylesForSummery } from '../Utils/customTableStyles';
import { userloginDetails } from '../Utils/AdminAuth';
import { HOST_URL } from '../Dashboard/api/Api';
import { IoLogoWhatsapp } from 'react-icons/io';
import { FaSms } from 'react-icons/fa';

class Home extends Component {

	constructor() {

		const lStorage = userloginDetails();
		const userId = lStorage?.user?.userId;
		const userToken = lStorage?.token;
		const isAdmin = lStorage?.user?.isAdmin;
		const channelPermissionsubadmin = lStorage?.user

		super();

		this.state = {
			user_id: userId,
			token: userToken,
			userType: isAdmin,
			channelPermissionsubadmin: channelPermissionsubadmin,
			allUserList: null,
			filterData: null,
			email_count: '',
			smscount: '',
			voice_count: '',
			per_request: '',
			count: '',
			dateFrom: '',
			dateTo: '',
			filterText: '',
			resetPaginationToggle: false,
			userCurrentStatus: '',
			successMessage: false,
			errorMessage: '',
			bgColor: '',
			crossIcons: false,
		}
		this.loginToUserAccount = this.loginToUserAccount.bind(this);
	}

	componentDidMount() {
		if (this.state.userType === "admin") {
			this.onserchAdmin();
		}
		else {
			this.onserch();
		}
		this.countAll();
	}

	onserchAdmin() {
		const { user_id, userType, token } = this.state;
		const baseUrl = `${HOST_URL}/admin_dashboard.php`;

		// Prepare the two payloads
		const payloads = [
			{
				user_id,
				method: "activeusers",
				type: userType,
				token
			},
			{
				user_id,
				method: "activeusers_wp",
				type: userType,
				token
			}
		];

		Promise.all(
			payloads.map(payload =>
				fetch(baseUrl, {
					method: 'POST',
					headers: {
						'Content-Type': 'application/json'
					},
					body: JSON.stringify(payload)
				}).then(res => res.json())
			)
		)
			.then(([res1, res2]) => {
				if (res1.success && res2.success) {
					// Step 1: Merge and sort all users
					const combinedData = [...res1.data, ...res2.data].sort(
						(a, b) => new Date(b.lastrequest) - new Date(a.lastrequest)
					);

					// Step 2: Merge users with same username and collect channels
					const mergedData = this.mergeUsersByUsername(combinedData);

					// Step 3: Set state
					this.setState({
						allUserList: mergedData,
						filterData: mergedData,
						count: mergedData.length,
						userCurrentStatus: mergedData[0]?.is_active || null
					});
				} else {
					const errorMessage = res1.success ? res2.message : res1.message;

					this.setState({
						successMessage: true,
						successBg: "alert alert-danger alert-dismissible",
						errorMessage: errorMessage
					});
				}
			})
			.catch(error => {
				console.error("API Error:", error);
				this.setState({
					successMessage: true,
					successBg: "alert alert-danger alert-dismissible",
					errorMessage: "An error occurred while fetching user data."
				});
			});
	}

	mergeUsersByUsername(data) {
		const userMap = new Map();

		data.forEach(entry => {
			const {
				username,
				total,
				channel,
				password,
				lastrequest,
				...rest
			} = entry;

			if (userMap.has(username)) {
				const existing = userMap.get(username);
				existing.total += Number(total); // sum totals

				// Add new channels dynamically
				if (!Object.values(existing).includes(channel)) {
					let count = 2;
					let channelKey = "secondChannel";

					while (existing[channelKey]) {
						count++;
						channelKey = this.numberToOrdinal(count) + "Channel";
					}

					existing[channelKey] = channel;
				}

				// Optionally update lastrequest to latest
				if (new Date(lastrequest) > new Date(existing.lastrequest)) {
					existing.lastrequest = lastrequest;
				}
			} else {
				userMap.set(username, { username, total: Number(total), password, channel, lastrequest, ...rest });
			}
		});

		return Array.from(userMap.values());
	}

	numberToOrdinal(n) {
		const ordinals = ["first", "second", "third", "fourth", "fifth"];
		return ordinals[n - 1] || `${n}th`;
	}



	onserch() {
		fetch(`${HOST_URL}/admin_dashboard.php`, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json'
			},
			body: JSON.stringify({
				user_id: this.state.user_id,
				method: 'activeusers',
				type: this.state.userType,
				token: this.state.token
			})
		})
			.then(response => response.json())
			.then(result => {
				if (result.success === true) {
					const SortedData = result.data.sort(
						(a, b) => new Date(b.lastrequest) - new Date(a.lastrequest)
					);
					this.setState({
						allUserList: SortedData,
						filterData: SortedData,
						count: Object.keys(SortedData).length,
						userCurrentStatus: SortedData[0].is_active
					});
				} else {
					this.setState({
						successMessage: true,
						successBg: "alert alert-danger alert-dismissible",
						errorMessage: result.message
					});
				}
			})
			.catch(error => {
				console.error('Error fetching data:', error);
			});
	}

	countAll() {
		fetch(`${HOST_URL}/admin_dashboard.php?user_id=${this.state.user_id}&method=count&token=${this.state.token}&date_from=${this.state.dateFrom}&date_to=${this.state.dateTo}`).then((response) => {
			response.json().then((result) => {
				if (result.success === true) {
					this.setState({
						smscount: result.message.sms_count,
						email_count: result.message.email_count,
						voice_count: result.message.voice_count,
						per_request: result.message.per_request
					})
				} else {
					this.setState({
						smscount: '0',
						email_count: '0',
						voice_count: '0',
						per_request: '0',
					})
				}
			})
		})
	}

	loginToUserAccount(emailaddress, password) {
		var url = document.location.href;
		const singleTemplateData = ({ username: emailaddress, password: password, admintype: this.state.userType });

		fetch(`${HOST_URL}/login.php`, {
			method: "post",
			headers: {
				'content-Type': 'application/json'
			},
			body: JSON.stringify(singleTemplateData)
		}).then((result) => {
			result.json().then((result) => {
				if (result.success === true) {
					result['url'] = url;
					localStorage.setItem('login', JSON.stringify(result));
					window.location.href = "/dashboard";
				} else {
					this.setState({
						successMessage: true,
						bgColor: "alert alert-danger alert-dismissible",
						errorMessage: result.message
					})
				}
			})
		})
	}

	dateFrom = (date) => {
		let dated = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + ("0" + date.getDate()).slice(-2);
		this.setState({
			dateFrom: dated,
			SelecteddateFrom: date
		});
	};

	dateTo = (date) => {
		let dated = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + ("0" + date.getDate()).slice(-2);
		this.setState({
			dateTo: dated,
			SelecteddateTo: date
		});
	};

	filterdata = (e) => {
		let searchTeram = e.target.value.toLowerCase();
		var newArray = this.state.allUserList.filter(function (el) {
			return el.username.indexOf(searchTeram) !== -1;
		});
		this.setState({
			filterData: newArray,
			crossIcons: true
		})
	}

	resetvalue = () => {
		this.setState({
			filterData: this.state.allUserList, crossIcons: false
		})
	}


	render() {
		console.log(this.state.filterData)

		const columns = [
			{
				name: 'Action',
				cell: (e) => <FontAwesomeIcon role='button' color="green" onClick={() => this.loginToUserAccount(e.username, e.password)} icon={faSignInAlt} />,
				width: '100px',

			},
			{
				name: 'Email ID / Username',
				selector: row => row.username,
				sortable: true,
			},
			{
				name: 'Request',
				selector: row => row.total,
				sortable: true,
				cell: (row) => (
					<div className="d-flex align-items-center">
						<strong className="text-primary mr-2">{row.total}</strong>
						{(row.channel === 'whatsapp' || row.secondChannel === "whatsapp") && (
							<IoLogoWhatsapp className="text-success" style={{ fontSize: '1.5em' }} />
						)}
						{(row.channel === 'sms' || row.secondChannel === "sms") && (
							<FaSms className="text-primary" style={{ fontSize: '1.5em' }} />
						)}
					</div>
				)
			},
			{
				name: ' Last Request Date Time',
				selector: row => row.lastrequest,
				sortable: true,
			},
			{
				name: 'Action',
				cell: (e) => <Link to={'/admin/api-request/' + e.username}><span className='badge bg-success mr-2'> View Details </span></Link>,
			},
		];

		const oneDayBefore = new Date();
		oneDayBefore.setDate(oneDayBefore.getDate() - 1);

		return (


			<main className="content">
				<div className="container-fluid p-0">
					<div className="row mb-3 mb-xl-3">
						<div className="col-auto d-none d-sm-block">
							<h3 className="mt-2"><strong>{this.state.userType === 'emp' ? 'Employee' : ''}{this.state.userType === 'admin' ? 'Admin' : ''}{this.state.userType === 'reseller' ? 'Reseller' : ''}</strong> Dashboard</h3>
						</div>

						<div className="col-auto ml-auto d-flex text-right mt-n1">

							<DatePicker className="form-control btn-block"
								dateFormat="yyyy/MM/dd"
								//value={this.state.dateFrom}
								onChange={this.dateFrom}
								maxDate={oneDayBefore}
								selected={this.state.SelecteddateFrom}
								placeholderText={this.state.dateFrom}
							/>

							<DatePicker className="form-control btn-block"
								dateFormat="yyyy/MM/dd"
								//value={this.state.dateTo}
								onChange={this.dateTo}
								maxDate={oneDayBefore}
								selected={this.state.SelecteddateTo}
								placeholderText={this.state.dateTo}
							/>

							<button onClick={() => this.countAll()} style={{ borderRadius: '20%', padding: '10px 15px' }} className="btn btn-sm btn-primary ml-2"><FontAwesomeIcon icon={faSearch} /> </button>


						</div>


					</div>

					<div className="row">
						<div className="col-xl-12  mt-3 col-xxl-5 d-flex">
							<div className="w-100">
								<div className="row">
									{(this.state.userType === "admin" || this.state.userType === "reseller" || this.state.userType === "emp" || (this.state.userType === "subadmin" && this.state.channelPermissionsubadmin.sms_menu === 1)) && 
									<div className="col-sm-3">
										<div className="card">
											<div className="card-body">
												<h5 className="card-title mb-4">SMS Summary</h5>
												<h2 className="mt-1 mb-3">{this.state.smscount}</h2>
											</div>
										</div>
									</div>}
									{(this.state.userType === "admin" || this.state.userType === "reseller" || this.state.userType === "emp" || (this.state.userType === "subadmin" && this.state.channelPermissionsubadmin.voice_menu === 1)) && <div className="col-sm-3">
										<div className="card">
											<div className="card-body">
												<h5 className="card-title mb-4">Voice Summary</h5>
												<h2 className="mt-1 mb-3">{this.state.voice_count}</h2>
											</div>
										</div>
									</div>}
									{(this.state.userType === "admin" || this.state.userType === "reseller" || this.state.userType === "emp" || (this.state.userType === "subadmin" && this.state.channelPermissionsubadmin.email_menu === 1)) && <div className="col-sm-3">
										<div className="card">
											<div className="card-body">
												<h5 className="card-title mb-4">Email Summary</h5>
												<h2 className="mt-1 mb-3">{this.state.email_count}</h2>
											</div>
										</div>
									</div>}
									<div className="col-sm-3">
										<div className="card">
											<div className="card-body">
												<h5 className="card-title mb-4">API Request / Mint </h5>
												<h2 className="mt-1 mb-3">{this.state.per_request}</h2>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>


					<div className="row">
						<div className="col-12 col-lg-12 col-xxl-12 d-flex">
							<div className="card flex-fill">

								<div className="card-header ">
									<h4 className="card-title d-flex justify-content-between mb-0"> <strong className='pt-3 '>Today Active Users : <span className='text-success'> {this.state.count} </span> </strong><strong> <input type='text' onChange={this.filterdata} placeholder='Search' className='form-control' />
										{this.state.crossIcons ?

											<FontAwesomeIcon onClick={this.resetvalue} className='reset-value' role='button' icon={faTimesCircle} />
											:
											null
										}

									</strong> </h4>
								</div>

								<div className="">


									<DataTable
										columns={columns}
										data={this.state.filterData || 0}
										pagination={this.state.allUserList ? true : false}
										customStyles={customTableStylesForSummery}
										highlightOnHover
										paginationRowsPerPageOptions={[10, 25, 50, 100]}
									/>



								</div>
							</div>
						</div>
					</div>

				</div>
			</main>

		);
	}
}

export default Home;